<template>
  <div class="home_container" :class="[isNewSkin ? 'home_container_bg_new' : 'home_container_bg']">
    <div class="header_container">
      <div class="logo">
        <img src="../assets/image/logo.png" alt />
      </div>
      <div class="centerBtn">
        <div class="RuleBtn" @click="activityRule()">
          <!-- 旧按钮路径 -->
          <img v-if="!isNewSkin" src="../assets/image/button/activityRule.png" alt />
          <!-- 新按钮路径 -->
          <img v-else src="../assets/image/gameImages/button/activityRule.png" alt />
        </div>
      </div>
      <div class="rightBtn">
        <div class="myGiftBtn" @click="myGiftBtn()">
          <!-- 旧按钮路径 -->
          <img v-if="!isNewSkin" src="../assets/image/button/myGift.png" alt />
          <!-- 新按钮路径 -->
          <img v-else src="../assets/image/gameImages/button/myGift.png" alt />
        </div>
      </div>
      <div class="rightIcon"></div>
    </div>
    <div class="content_container">
      <div class="content_box" :class="[isNewSkin ? 'content_box_bg_new' : 'content_box_bg']">
        <div class="indexLine">
          <img src="../assets/image/addressText.png" alt />
        </div>
        <div class="input_box">
          <van-row class="m_b10">
            <van-col span="7" class="c_w m_b5 f_12" style="line-height: 35px;">姓名：</van-col>
            <van-col span="17" class="c_w m_b5">
              <div class="name_box">
                <div class="innerInput">
                  <van-field v-model="userName" placeholder="请输入姓名"  @blur="onBlurInput()" />
                </div>
              </div>
            </van-col>
          </van-row>
          <van-row class="m_b10">
            <van-col span="7" class="c_w m_b5 f_12" style="line-height: 35px;">省市区：</van-col>
            <van-col span="17" class="c_w m_b5">
              <div class="name_box">
                <div class="innerInput">
                  <van-field v-model="shengshiqu" :readonly="true" placeholder="请选择省市区" @click="show=true" />
                </div>
              </div>
            </van-col>
          </van-row>
          <van-row class="m_b10">
            <van-col span="7" class="c_w m_b5 f_12" style="line-height: 35px;">地址：</van-col>
            <van-col span="17" class="c_w m_b5">
              <div class="name_box">
                <div class="innerInput">
                  <van-field v-model="addressDetail" placeholder="请输入详细地址" @blur="onBlurInput()" />
                </div>
              </div>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="7" class="c_w m_b5 f_12" style="line-height: 35px;">手机号：</van-col>
            <van-col span="17" class="c_w m_b5">
              <div class="name_box">
                <div class="innerInput">
                  <van-field v-model="phoneNumber" placeholder="请输入手机号" @blur="onBlurInput()" />
                </div>
              </div>
            </van-col>
          </van-row>
          <van-row class="m_b15">
            <van-col span="10"></van-col>
            <van-col span="14" class="c_w t_ar f_12">*请输入您的手机号码</van-col>
          </van-row>
          <van-row>
            <van-col span="24">
              <!-- 灰色背景 -->
              <div v-if="isRed == 0" class="grayBtn" @click="toToast()">立即填写</div>
              <div v-else style="width: 80%; margin: 0 auto;" @click="toToast()">
                <img :src="isNewSkin ? require('../assets/image/gameImages/button/confirmBtn.png') : require('../assets/image/button/confirmBtn.png')" style="width: 100%;" />
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-area :area-list="areaList" @cancel="cancelBtnTan" @confirm="confirmBtnTan" />
    </van-popup>

  </div>
</template>

<script>
import areaList from "../assets/newArea";
import {Dialog, Toast} from "vant";
export default {
  data() {
    return {
      userName: "",
      shengshiqu: "",
      addressDetail: "",
      phoneNumber: "",
      show: false,
      areaList: areaList,
      isRed: 1,
      isNewSkin: false, // 是否新皮肤
    };
  },
    mounted() {
      if (this.$route.query.check) {
        this.userName = this.$route.query.name ? this.$route.query.name : ''
        this.shengshiqu = this.$route.query.shengshiqu ? this.$route.query.shengshiqu : ''
        this.addressDetail = this.$route.query.addressDetail ? this.$route.query.addressDetail : ''
        this.phoneNumber = this.$route.query.phoneNumber ? this.$route.query.phoneNumber : ''
        this.isRed = this.$route.query.isRed
      }

      this.isNewSkin = sessionStorage.getItem('isNewSkin') ? true : false;
    },
    methods: {
    onBlurInput() {
			window.scroll(0, 0)
    },
    activityRule() {
      this.$router.push({ name: "activityRule" });
    },
    myGiftBtn() {
      this.$router.push({ name: "myGiftAll" });
    },
    async confirmBtn() {
      if (this.userName.trim() === "") {
        return Toast("请输入姓名");
      } else if (this.shengshiqu.trim() === "") {
        return Toast("请选择省市区");
      } else if (this.addressDetail.trim() === "") {
        return Toast("请输入详细地址");
      } else if (this.phoneNumber.trim() === "") {
        return Toast("请输入手机号");
      }
      let params = {
        address: `${this.shengshiqu}${this.addressDetail}`,
        shengshiqu: this.shengshiqu,
        detailAddress: this.addressDetail,
        name: this.userName,
        phone: this.phoneNumber,
        callbackUUId: this.$route.query.uid,
        orderNo: this.$route.query.orderNo
      }

      try {
        let {data: result} = await this.$post('addExpressInformation', params);
        if (result.code !== 200) {
          return Toast(result.errMsg);
        }
        if (this.$route.query.check) {
            Toast("地址修改成功!");
        } else {
            Toast("地址提交成功");
        }
        setTimeout(() => {
          this.$router.push({ name: "addressConfirm" });
        }, 500);
      } catch(err) {
        console.log(err);
      }
    },
      // 填写信息: -- 灰色背景--toast提示
      async toToast() {
        try {
          let params = {
            orderNo: this.$route.query.orderNo,
          };
          let { data: result } = await this.$get('checkWriteAddress', params);
          if (result.code !== 200) {
            //   return Toast(result.errMsg);
            Dialog.alert({
              message: result.errMsg,
              confirmButtonText: "我知道了"
            }).then(() => {
              // on close
            });
          } else {
            this.confirmBtn()
          }
        } catch (err) {
          console.log(err);
        }
      },
    cancelBtnTan() {
      this.show = false;
    },
    confirmBtnTan(val) {
      let str = "";
      val.forEach(item => {
        str += item.name;
      })
      this.shengshiqu = str;
      this.show = false;
    }
  },
  beforeCreate() {
    document.title = "抽奖";
  }
};
</script>

<style lang="scss">
.van-dialog__confirm, .van-dialog__confirm:active {
  color: #1989fa !important;
  background-color: white !important;
}
.van-dialog__message {
  font-weight: normal !important;
}
</style>

<style lang="scss" scoped>
/deep/.van-cell {
  width: 100%;
  height: 100%;
  background-color: #dcf6ff;
  line-height: 35px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.home_container {
  width: 100%;
  height: 100%;
  // background-image: url("../assets/image/bgc01.png");
  // background-size: 100% 100%;
  // background-repeat: repeat-y;
  // background-attachment: fixed;
  // background-image: url("../assets/image/bgc01.png");
  background-size: 100% 100%;
  padding-top: 20px;
  .header_container {
    width: 100%;
    height: 60px;
    display: flex;
    .logo {
      flex: 3;
      padding-left: 15px;
      img {
        width: 100%;
      }
    }
    .centerBtn {
      flex: 2;
      padding-left: 20px;
      .RuleBtn {
        width: 90%;
        height: 100%;
        img {
          width: 100%;
        }
      }
    }
    .rightBtn {
      flex: 2;
      padding-left: 10px;
      .myGiftBtn {
        width: 90%;
        height: 100%;
        img {
          width: 100%;
        }
      }
    }
    .rightIcon {
      width: 20px;
      padding-left: 10px;
      padding-top: 5px;
      img {
        width: 50%;
      }
    }
  }
  .content_container {
    margin-top: 30px;
    width: 100%;
    height: 500px;
    .content_box {
      width: 370px;
      height: 100%;
      margin: 0 auto;
      // background-image: url(../assets/image/blueBgc02.png);
      background-size: cover;
      padding-top: 90px;
      .indexLine {
        width: 55%;
        height: 90px;
        margin: 0 auto;
        img {
          width: 100%;
        }
      }
      .input_box {
        width: 57%;
        height: 30px;
        margin: 0 auto;
        .name_box {
          width: 100%;
          height: 35px;
          background-image: url(../assets/image/input/addressInput.png);
          background-size: 100% 100%;
        }
        .innerInput {
          width: 90%;
          height: 100%;
          margin: 0 auto;
        }
      }
    }
    .content_box_bg {
      // 旧背景路径
      background-image: url('../assets/image/blueBgc02.png');
    }
    .content_box_bg_new {
      // 新背景路径
      background-image: url('../assets/image/gameImages/blueBgc02.png');  
    }
  }
}
.home_container_bg {
  // 旧背景路径
	background-image: url('../assets/image/bgc01.png');
}
.home_container_bg_new {
  // 新背景路径
  background-image: url('../assets/image/gameImages/bgc01.png');
}

.grayBtn {
  background-color: rgb(204, 204, 204);
  color: rgb(168, 168, 168);
  display: inline-block;
  text-align: center;
  height: 40px;
  line-height: 40px;
  width: 250px;
}
</style>